import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetReasonGroupsInputDto, ReasonGroupCreateDto, ReasonGroupDto, ReasonGroupExcelDownloadDto, ReasonGroupUpdateDto } from '../dtos/reason-group/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ReasonGroupService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: ReasonGroupCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonGroupDto>({
      method: 'POST',
      url: '/api/general/reasonGroups',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/reasonGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/reasonGroups',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonGroupDto>({
      method: 'GET',
      url: `/api/general/reasonGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/reasonGroups/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetReasonGroupsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ReasonGroupDto>>({
      method: 'GET',
      url: '/api/general/reasonGroups',
      params: { name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ReasonGroupExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/reasonGroups/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonGroupDto[]>({
      method: 'GET',
      url: '/api/general/reasonGroups/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ReasonGroupUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonGroupDto>({
      method: 'PUT',
      url: `/api/general/reasonGroups/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}